import * as React from 'react';
import { getCommunityManagers } from '@/api/communities';
import { useQuery } from '@tanstack/react-query';

import { useDialog } from '@/hooks/v2/use-dialog';
import { useUser } from '@/hooks/v2/use-user';

import { ManagersTable } from './components/managers-table';

export function CommunityManagersPage(): React.JSX.Element {
  const dialog = useDialog();
  const { community } = useUser();
  if (!community) {
    return <div>No community found</div>;
  }
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['managers', community?.id],
    queryFn: () => getCommunityManagers(community?.id),
  });

  const handleOnSuccess = React.useCallback(async () => {
    await refetch();
    dialog.handleClose();
  }, [dialog, refetch]);

  const managers = data?.managers;
  return <ManagersTable loading={isLoading} onCreated={handleOnSuccess} rows={managers ?? []} />;
}
